'use client';
/**
 * UN SEUL MENU « RÉFÉRENTIEL » (Ines, 17-18/10/2026, point 6 de la refonte).
 *
 * Trois entrées de la barre latérale voisinaient avec le référentiel des
 * analyses et décrivaient le même catalogue sous trois angles : les critères
 * d'acceptation des échantillons, les intervalles de référence et les critères
 * de performance. « Il y a trop de choses et on ne sait pas où chercher. »
 *
 * Elles ne sont plus dans la barre (`horsBarre`, toujours dans la palette de
 * recherche) : on y arrive par CETTE barre, posée en tête du référentiel et de
 * chacun des trois écrans, qui dit où l'on est et où l'on peut aller. Les
 * écrans eux-mêmes ne bougent pas, ni leurs adresses (`/criteres-acceptation`,
 * `/intervalles-reference`, `/criteres-performance` — des contrats), ni leurs
 * codes de section : fermer les intervalles à quelqu'un ne ferme pas le
 * catalogue, et la barre ne lui montre que ce qu'il peut ouvrir.
 */
import React from 'react';
import { useGed } from '@/lib/store';
import { droitsNav } from '@/lib/navigation';
import type { GedView } from '@/lib/types';
import { Segment } from '@/shared/Segment';

const VUES: { vue: GedView; section: string; libelle: string; aide: string }[] = [
  { vue: 'manuel', section: 'manuel', libelle: 'Examens & paramètres', aide: 'Le catalogue : examens, paramètres, techniques, circuit, paramétrage' },
  { vue: 'criteres', section: 'criteres', libelle: 'Critères d’acceptation', aide: 'Ce que le laboratoire accepte de recevoir — la grille des motifs de refus' },
  { vue: 'revueref', section: 'revueref', libelle: 'Intervalles de référence', aide: 'Les bornes rendues, leur revue périodique, les tranches pédiatriques' },
  { vue: 'refperf', section: 'refperf', libelle: 'Critères de performance', aide: 'Les limites d’acceptabilité (SFBC, RICOS, CLIA…) avec leur source' },
];

export function RegistresLies({ actif }: { actif: GedView }) {
  const { session, rhAcces, go } = useGed();
  const d = droitsNav(session, !!rhAcces?.acces);
  const visibles = VUES.filter((v) => v.vue === actif || d.section(v.section));
  // Seul : rien à choisir, on ne dessine pas un rail d'une option.
  if (visibles.length < 2) return null;
  return (
    <div style={{ margin: '12px 0 4px' }}>
      <Segment ariaLabel="Registres du référentiel" valeur={actif} onChange={(v) => go(v)}
        options={visibles.map((v) => ({ valeur: v.vue, libelle: v.libelle, aide: v.aide }))} />
    </div>
  );
}
